module.exports = __webpack_public_path__ + "img/people.7512878a.svg";